module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921065334_T.76413e55.jpg";